import {
  ROOT_PATH,
  LIVROS_HOME_ROOT_PATH,
  ATUALIDADES_HOME_ROOT_PATH,
  INGLES_HOME_ROOT_PATH,
  SENTIR_HOME_ROOT_PATH,
  LER_HOME_ROOT_PATH,
  LER_REVISTAS_E_JORNAIS_HOME_ROOT_PATH,
  LER_NOTICIAS_HOME_ROOT_PATH,
  COMUNICAR_HOME_ROOT_PATH
} from 'routes/paths'
import type { LocationType } from './types'
import { Module } from 'utils/user'
import type { UserState } from 'utils/hooks/use-userInfo'
import {
  criarUrl,
  escritaUrl,
  getSuperAutorUrl
} from 'components/modular/tabs-home/constants'

function getRedirectLocation(
  user: UserState,
  currentPath: string,
  isSuperAutorEligible?: boolean
): LocationType {
  if (Module.userHasOnlyCriarAccess(user)) {
    window.location.href = isSuperAutorEligible ? getSuperAutorUrl() : criarUrl
    return {
      pathname: ''
    }
  }

  if (Module.userHasOnlyWritingAccess(user)) {
    return {
      pathname: escritaUrl
    }
  }

  const MODULAR_PATHS = [
    LIVROS_HOME_ROOT_PATH,
    ATUALIDADES_HOME_ROOT_PATH,
    INGLES_HOME_ROOT_PATH,
    SENTIR_HOME_ROOT_PATH,
    LER_HOME_ROOT_PATH,
    LER_REVISTAS_E_JORNAIS_HOME_ROOT_PATH,
    LER_NOTICIAS_HOME_ROOT_PATH,
    COMUNICAR_HOME_ROOT_PATH
  ]

  if (
    currentPath === ROOT_PATH ||
    (MODULAR_PATHS.includes(currentPath) &&
      !Module.userCanAccessModulePath(user, currentPath))
  ) {
    return {
      pathname: Module.getDefaultModulePath(user)
    }
  }

  return {
    pathname: ''
  }
}

export default {
  getRedirectLocation
}
